import React from 'react';
import ReactSlider from 'react-slider';
import { SliderMark, SliderThumb, SliderTrail, SliderWrapper } from './styles/RangeSlider.styled';

export default function RangeSlider({ min, max, defaultValue, step, marks, dir }) {
  const settings = {
    defaultValue,
    max,
    min,
    step,
    marks,
    renderThumb: (props, state) => <SliderThumb {...props}>{state.valueNow}</SliderThumb>,
    renderMark: (props) => (
      <SliderMark {...props} dir={dir}>
        {props.key}
      </SliderMark>
    ),
    // onBeforeChange: (value) => console.log(`ON_BEFORE_CHANGE: ${value})}`),
    // onChange: (value) => console.log(`ON_CHANGE: ${value})}`),
    onAfterChange: (value) => {
      const el = document.getElementById('howManyAttendeesExpected');
      el.value = value;
    },
  };

  return (
    <SliderWrapper>
      <SliderTrail />
      <ReactSlider {...settings} />
    </SliderWrapper>
  );
}
